<template>
  <div>
    <b-modal
    id="ImprovementPost"
    size="lg"
    :title="postData.title"
    hide-footer>
        <b-overlay :show="loading">
            <post :postItem="postData" :categoriesData="postData.categories"></post>
        </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import Post from './Post.vue';
export default {
    components: {
        Post
    },
    props: ['postData', 'postCategories'],
    data(){
        return {
            loading: false,
            post: null
        }
    },
    created() {
        this.$root.$on('ImprovementPost', () => {
            this.$bvModal.show('ImprovementPost')
        });
    },

    methods: {
        load(){
            this.loading = true
            axios.get(`/teacher/solicitation/${this.postId}`)
            .then((result) => {
                const response = result.data.data.post

                this.post = response

            }).catch((err) => {

            }).finally(()=> this.loading=false);
        }
    },
}
</script>

<style>

</style>
